"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _upload = _interopRequireDefault(require("@/components/upload"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    upload: _upload.default
  },
  data: function data() {
    return {
      proportion: {
        1: '3:3.75',
        2: '4:1',
        3: '2:1',
        4: '2:1'
      },
      positionList: [],
      form: {
        position_id: ''
      },
      time: [],
      fileList: [],
      id: ''
    };
  },
  mounted: function mounted() {
    if (this.$route.query.pid) this.form.position_id = parseInt(this.$route.query.pid);
    if (this.$route.query.id > 0) {
      this.id = this.$route.query.id;
      this.getInfo();
    }
    this.getPower();
  },
  methods: {
    /**
     * 获取可以添加的广告位
     */
    getPower: function getPower() {
      var _this = this;
      this.$get('agentapi/get_ad_auths').then(function (res) {
        _this.positionList = res;
      });
    },
    /**
     * 获取商户信息
     */
    getInfo: function getInfo() {
      var _this2 = this;
      this.$get('agentapi/ad_detail', {
        id: this.id
      }).then(function (res) {
        _this2.time = [res.info.start_date * 1000, res.info.end_date * 1000];
        _this2.fileList = [{
          url: res.info.img_url
        }];
        res.info.is_all = res.info.is_all == 1 ? true : false;
        _this2.form = res.info;
      });
    },
    onSubmit: function onSubmit() {
      var _this3 = this;
      var params = this.form,
        url = 'agentapi/add_ad';
      if (this.time[1] <= this.time[0]) {
        this.$message({
          message: '广告投放结束时间必须大于开始时间',
          type: 'error'
        });
        return;
      }
      params.start_date = this.parseTime(this.time[0]);
      params.end_date = this.parseTime(this.time[1]);
      if (this.id > 0) {
        params.id = this.id;
        url = 'agentapi/edit_ad';
      }
      params.is_all = params.is_all ? 1 : 0;

      // 【操作埋点】2026-05-25 pc_ad_create_1 创建/编辑广告
      var adReportMeta = this.id > 0 ? this.$buildAdminOperationReportMeta({
        operation_option: '编辑广告',
        content: "\u7F16\u8F91\u5E7F\u544A\u300C".concat(params.ad_name || '', "\u300D\uFF0C\u5E7F\u544A\u4F4DID ").concat(params.position_id, "\uFF0C\u6295\u653E ").concat(params.start_date, " \u81F3 ").concat(params.end_date, "\uFF0C\u5168\u5E73\u53F0\uFF1A").concat(params.is_all ? '是' : '否'),
        operation_id: 'pc_ad_create_1'
      }) : this.$buildAdminOperationReportMeta({
        operation_option: '创建广告',
        content: "\u521B\u5EFA\u5E7F\u544A\u300C".concat(params.ad_name || '', "\u300D\uFF0C\u5E7F\u544A\u4F4DID ").concat(params.position_id, "\uFF0C\u6295\u653E ").concat(params.start_date, " \u81F3 ").concat(params.end_date, "\uFF0C\u5168\u5E73\u53F0\uFF1A").concat(params.is_all ? '是' : '否'),
        operation_id: 'pc_ad_create_1'
      });
      this.$post(url, params, adReportMeta).then(function (res) {
        _this3.$message({
          message: '提交成功',
          type: 'success'
        });
        _this3.$router.push({
          path: '/adver/photo',
          query: {
            'pid': _this3.form.position_id
          }
        });
      });
    },
    /**
     * 上传文件成功通知
     */
    fileOk: function fileOk(arr) {
      this.form.img_url = arr[0] || '';
    }
  }
};